var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-contract-pic" },
    [
      _vm._l(_vm.list, function (item) {
        return _c("div", { key: item, staticClass: "img-box" }, [
          _c(
            "div",
            {
              staticClass: "btn-delete",
              on: {
                click: function ($event) {
                  return _vm.deleteImage(item)
                },
              },
            },
            [_c("img", { attrs: { src: require("../images/delete.png") } })]
          ),
          _vm._v(" "),
          _c("img", {
            attrs: { src: item },
            on: {
              click: function ($event) {
                return _vm.previewImage(item)
              },
            },
          }),
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c("div", { staticClass: "btn-add", on: { click: _vm.addImage } }, [
          _vm._v("添加附件"),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }